import axios from "axios";

const ENV_URL = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Resolve the backend URL.
 * - If we're running on the same domain as the backend (regardless of www. prefix),
 *   use a RELATIVE URL so requests stay on the current origin and avoid the
 *   non-www <-> www redirect (which breaks browser POST requests).
 * - Otherwise (preview / different host), use the explicit env URL.
 */
function resolveBackendURL() {
  if (typeof window === "undefined" || !ENV_URL) return ENV_URL;
  try {
    const envHost = new URL(ENV_URL).hostname.replace(/^www\./, "");
    const curHost = window.location.hostname.replace(/^www\./, "");
    if (envHost === curHost) return ""; // same origin → relative
  } catch (e) {
    // malformed URL, fall through
  }
  return ENV_URL;
}

const BACKEND_URL = resolveBackendURL();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cw_admin_token");
  if (token && config.url?.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fmtHUF = (n) => `${Number(n).toLocaleString("hu-HU")} Ft`;
